import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import withPopupErrors from '../../../components/HOC/withPopupErrors/withPopupErrors';

import compare from '../../../lib/compare';
import usePagination from '../../../lib/hooks/usePagination';
import { useFilters } from '../../../components/common/Filters/Filters';
import { selectMunicipalities } from '../../../redux/reducers/MunicipalitiesReducer';

import ActionsBar from '../../../components/common/ActionsBar/ActionsBar';
import MunicipalitiesFilters from '../../../components/admin/MunicipalitiesList/Filters';
import CreateMunicipalityForm from '../../../components/admin/MunicipalitiesList/CreationForm';
import MunicipalitiesTable from '../../../components/admin/MunicipalitiesList/Table';

import plusIcon from '../../../assets/add.svg';

interface Props {
  unauthorizedCallback: () => void;
  showError: (text: string) => void;
}

const MunicipalitiesPage = ({ unauthorizedCallback, showError }: Props) => {
  const [showCreateWindow, setShowCreateWindow] = useState(false);
  const [filters, setFilter] = useFilters({ name: '' });
  const [sortData, setSortData] = useState({
    column: 'Название',
    descending: false,
  });

  const municipalities = useSelector(selectMunicipalities);
  const filteredAndSortedMunicipalities = Object.values(municipalities)
    .filter((municipality) =>
      new RegExp(filters.name, 'i').test(municipality.name),
    )
    .sort((first, second) => compare(first.name, second.name));

  if (sortData.descending) filteredAndSortedMunicipalities.reverse();

  const { paginator, page } = usePagination(
    Math.ceil(filteredAndSortedMunicipalities.length / 10),
  );

  const municipalitiesForRender = filteredAndSortedMunicipalities.slice(
    (page - 1) * 10,
    page * 10,
  );

  return (
    <div style={{ display: 'flex', gap: '5rem' }}>
      <div style={{ width: '45vw', minWidth: '20rem' }}>
        <ActionsBar
          actionButtons={[
            {
              src: plusIcon,
              alt: 'Добавить муниципалитет',
              placement: 'right',
              onClick: () => setShowCreateWindow(true),
            },
          ]}
        />

        <MunicipalitiesTable
          municipalities={municipalitiesForRender}
          unauthorizedCallback={unauthorizedCallback}
          showError={showError}
          sortData={sortData}
          setSortData={setSortData}
        />

        {paginator}
      </div>

      <MunicipalitiesFilters filters={filters} setFilter={setFilter} />

      {showCreateWindow && (
        <CreateMunicipalityForm onClose={() => setShowCreateWindow(false)} />
      )}
    </div>
  );
};

export default withPopupErrors<Props>(MunicipalitiesPage);
